import React, {Component} from "react";

export default class Layer4 extends Component {


    render() {
        return <div className="layer4">
            <div className="announcement">This is beta version 0.0.0.6!</div>
        </div>
    }
}
